'use client';
import EfImg, { EfImgProps } from '../ef-img';
import EfVideo, { EfVideoProps } from '../ef-video';

export interface BhImgVideoProps extends EfVideoProps, EfImgProps {
    /**
     * 是否是视频
     */
    isVideo?: boolean;
}

/**
 * 根据 isVideo 组合 BhImg | BhVideo
 */
export default function BhImgVideo({ isVideo = false, pc, pad, h5, ...rest }: BhImgVideoProps) {
    return (
        <>
            {!isVideo && <EfImg pc={pc} pad={pad} h5={h5} {...rest} />}
            {isVideo && pc && <EfVideo pc={pc} pad={pad} h5={h5} {...rest} />}
        </>
    );
}
